













module.exports = {
  "modal":   {
    "modal": () => import("../modal/modal.js")
  },
  "slider":   {
    "slider-plugins": () => import("../slider/slider-plugins.js"),
    "slider": () => import("../slider/slider.js")
  },
  "table-of-contents":   {
    "table-of-contents": () => import("../table-of-contents/table-of-contents.js")
  },
  "timeline":   {
    "timeline": () => import("../timeline/timeline.js")
  },
  "videos":   {
    "video": () => import("../videos/video.js")
  },
  "header":   {
    "nav-primary":     {
      "nav-primary": () => import("../header/nav-primary/nav-primary.js")
    }
  }
}